import React, { useState } from "react";
import ProfileOptions from "./ProfileOptions";
import UserAvatar from "../UserAvatar/UserAvatar";

function ProfileOptionsWrapper(props) {
  const [showOptions, setShowOptions] = useState(false);
  const toogleProfileOptions = () => {
    setShowOptions(!showOptions);
  };
  return props.link === "dashboard" ? (
    <div className="profile-options" onClick={toogleProfileOptions}>
      <UserAvatar styleName="navbar-profile" />
      {showOptions && <ProfileOptions {...props} />}
    </div>
  ) : (
    <ProfileOptions handleSelectOption={props.onSelectOption} />
  );
}

export default ProfileOptionsWrapper;
